import { TableField } from "../../table-field";

const codUg: TableField = {
    key: "CodUgSagres",
    label: "Código",
    tdClass: ["align-middle", "naoQuebrar"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: true,
};
const nomeUg: TableField = {
    key: "UgNmNome",
    label: "Nome",
    tdClass: ["align-middle", "quebrarPorPalavraHard"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: true,
};
const municipioUg: TableField = {
    key: "MunicipioNmNome",
    label: "Município",
    tdClass: ["align-middle", "quebrarPorPalavraHard"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: true,
};
const actions = {
    key: "actions",
    label: "Ações",
    tdClass: ["align-middle", "col-actions"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: false,
};

export const fieldsUGs: TableField[] = [
    codUg,
    nomeUg,
    municipioUg,
    actions,
];